import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type {
  CreateVehicleModelPayload,
  UpdateVehicleModelPayload,
  VehicleModel,
  VehicleModelDeletePreview,
} from "#/types/vehicle-model";

export const vehicleModelApi = {
  create: (body: CreateVehicleModelPayload): Promise<ApiResponse<VehicleModel>> =>
    api.post("/vehicle-model", body),
  getAll: (
    params?: BaseFilterParams
  ): Promise<ApiResponse<Paginated<VehicleModel[]>>> =>
    api.get("/vehicle-model", { params }),
  getById: (id: number): Promise<ApiResponse<VehicleModel>> =>
    api.get(`/vehicle-model/${id}`),
  update: (
    id: number,
    body: Partial<UpdateVehicleModelPayload>
  ): Promise<ApiResponse<VehicleModel>> => api.patch(`/vehicle-model/${id}`, body),
  /** What depends on the model: deletion is refused while vehicles use it. */
  getDeletePreview: (id: number): Promise<ApiResponse<VehicleModelDeletePreview>> =>
    api.get(`/vehicle-model/${id}/delete-preview`),
  delete: (id: number): Promise<ApiResponse<void>> =>
    api.delete(`/vehicle-model/${id}`),
};
